'use client';

import SectionTitle from '@/components/section-title/section-title';
import { useTranslations } from 'next-intl';

export default function WebinarSectionTitle() {
  const t = useTranslations();

  return <SectionTitle align="center">{t('navigation.webinars')}</SectionTitle>;
}
